import { CloudServerOutlined, ExperimentOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import { useConfig } from "../../contexts/ConfigContext";
import { esEntornoDePruebas, nombreCortoDeLaEmpresa } from "../../utils/entornoActivo";

/**
 * En qué corporativo y en qué empresa se está trabajando.
 *
 * Se enseña **siempre**, y el color dice de qué clase de entorno se trata. Ésa
 * es la mitad del valor: el riesgo real no es no saber la empresa, sino creerse
 * en pruebas estando en producción, o al revés. Un rótulo neutro no avisa de
 * eso; un color sí.
 *
 * El corporativo entero no cabe en la cabecera --«Corporativo_Santillana_2_Dev»
 * ocupa más que el buscador-- así que se enseña la empresa, recortada, y el
 * detalle completo va al posar el puntero.
 */
const EntornoActivo = () => {
  const { activeEnv, country } = useConfig();

  // Sin entorno cargado no se dibuja nada. Un hueco es preferible a un
  // distintivo a medias, que en este caso diría «producción» por defecto.
  if (!activeEnv?.company && !activeEnv?.env) return null;

  const esPruebas = esEntornoDePruebas(activeEnv?.env);
  const empresa = nombreCortoDeLaEmpresa(activeEnv?.company) || "Sin empresa";

  return (
    <Tooltip
      title={
        <span>
          <b>Empresa:</b> {activeEnv?.company || "sin nombre"}
          <br />
          <b>Corporativo:</b> {activeEnv?.env || "sin entorno"}
          <br />
          <b>País:</b> {country?.name || activeEnv?.country || "sin país"}
          <br />
          {esPruebas
            ? "Entorno de pruebas: lo que se registre aquí no es real."
            : "Entorno de producción: lo que se registre aquí es real."}
        </span>
      }
    >
      <Tag
        icon={esPruebas ? <ExperimentOutlined /> : <CloudServerOutlined />}
        color={esPruebas ? "warning" : "default"}
        style={{ margin: 0, whiteSpace: "nowrap", maxWidth: 220 }}
      >
        {esPruebas ? `PRUEBAS · ${empresa}` : empresa}
      </Tag>
    </Tooltip>
  );
};

export default EntornoActivo;
